import { ApolloProvider } from "@apollo/client";
import { AppRoute } from "./Routes";
import { FlexCenterColumnAndRow } from "./components/Layout";
import { Spin } from "antd";
import { createApolloClient } from "./graphql";
import { useAppContext } from "./context/app/context";
import { useAuthenticate } from "./hooks/useAuthenticate";

export function App() {
  const appContext = useAppContext();
  const { loading } = useAuthenticate();

  if (loading) {
    return (
      <FlexCenterColumnAndRow>
        <Spin size="large" />
      </FlexCenterColumnAndRow>
    );
  }
  return (
    <ApolloProvider
      client={createApolloClient(
        appContext.state.odooSession?.j_sid ||
          (process.env.REACT_APP_ODOO_SESSION_ID as string),
        appContext.state.odooSession?.db ||
          (process.env.REACT_APP_ODOO_SESSION_DB as string)
      )}
    >
      <AppRoute />
    </ApolloProvider>
  );
}
